// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import __setDefaultSdkOptions from "../sdk-helpers/__setDefaultSdkOptions";

import createEventAlertKindsGet from "./event/postEventAlertKindsGet";
import createEventBoxScoreGet from "./event/postEventBoxScoreGet";
import createEventCalendarGet from "./event/postEventCalendarGet";
import createEventDaysWithGamesList from "./event/postEventDaysWithGamesList";
import createEventDetailGet from "./event/postEventDetailGet";
import createEventInjuriesGet from "./event/postEventInjuriesGet";
import createEventLastPlayedGet from "./event/postEventLastPlayedGet";
import createEventLineupsGet from "./event/postEventLineupsGet";
import createEventList from "./event/postEventList";
import createEventLiveStreamGet from "./event/postEventLiveStreamGet";
import createEventPlayerBoxScoreGet from "./event/postEventPlayerBoxScoreGet";
import createEventPlayerGameLogGet from "./event/postEventPlayerGameLogGet";
import createEventPlaysGet from "./event/postEventPlaysGet";
import createEventTeamScheduleGet from "./event/postEventTeamScheduleGet";
import createEventWeekList from "./event/postEventWeekList";
import createEventWeeksWithGamesList from "./event/postEventWeeksWithGamesList";
import createFeedUpcoming from "./feed/postFeedUpcoming";

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

// Every method is built from RESOLVED options, never the raw argument.
// `sdk()` with no arguments has to work. That is the shape every generated
// hook uses through useCallSdk(), and passing the raw `undefined` through
// gave those methods no apiHost and no "/v1/<zone>" prefix, so they POSTed to
// a bare relative "/resource/action".
export default function sdk(options?: SdkOptions) {
  const resolvedOptions = __setDefaultSdkOptions(options);
  return {
    postEventAlertKindsGet: createEventAlertKindsGet(resolvedOptions),
    postEventBoxScoreGet: createEventBoxScoreGet(resolvedOptions),
    postEventCalendarGet: createEventCalendarGet(resolvedOptions),
    postEventDaysWithGamesList: createEventDaysWithGamesList(resolvedOptions),
    postEventDetailGet: createEventDetailGet(resolvedOptions),
    postEventInjuriesGet: createEventInjuriesGet(resolvedOptions),
    postEventLastPlayedGet: createEventLastPlayedGet(resolvedOptions),
    postEventLineupsGet: createEventLineupsGet(resolvedOptions),
    postEventList: createEventList(resolvedOptions),
    postEventLiveStreamGet: createEventLiveStreamGet(resolvedOptions),
    postEventPlayerBoxScoreGet: createEventPlayerBoxScoreGet(resolvedOptions),
    postEventPlayerGameLogGet: createEventPlayerGameLogGet(resolvedOptions),
    postEventPlaysGet: createEventPlaysGet(resolvedOptions),
    postEventTeamScheduleGet: createEventTeamScheduleGet(resolvedOptions),
    postEventWeekList: createEventWeekList(resolvedOptions),
    postEventWeeksWithGamesList: createEventWeeksWithGamesList(resolvedOptions),
    postFeedUpcoming: createFeedUpcoming(resolvedOptions),
  };
}
